import { APP_NAME } from '@/lib/utils/constants';
import { API_BASE_URL } from '@/lib/api/apiClient';
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'hero' | 'giant';
  showName?: boolean;
  nameColor?: string;
  animateImage?: boolean;
}

export const Logo = ({ size = 'md', showName = true, nameColor = 'text-gray-800', animateImage = false }: LogoProps) => {
  const [imageError, setImageError] = useState(false);

  const sizeClasses = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16 md:w-20 md:h-20',
    lg: 'w-24 h-24 md:w-28 md:h-28',
    xl: 'w-32 h-32 md:w-40 md:h-40',
    hero: 'w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64',
    giant: 'w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96',
  };

  const textSizeClasses = {
    sm: 'text-xl',
    md: 'text-2xl md:text-3xl',
    lg: 'text-3xl md:text-4xl',
    xl: 'text-4xl md:text-5xl',
    hero: 'text-5xl md:text-6xl lg:text-7xl',
    giant: 'text-6xl md:text-7xl lg:text-8xl',
  };

  return (
    <Link to="/" className="flex items-center gap-4 hover:opacity-95 transition-opacity group">
      <div 
        className={`${sizeClasses[size]} flex-shrink-0 transition-transform group-hover:scale-105`}
        style={animateImage ? { animation: 'bounce-vertical 1.5s ease-in-out infinite' } : undefined}
      >
        {!imageError ? (
          <img 
            src={API_BASE_URL ? `${API_BASE_URL}/Brain.jpeg` : '/Brain.jpeg'}
            alt="اعصر مخك" 
            className="w-full h-full object-contain"
            style={{ 
              filter: 'drop-shadow(0 4px 6px rgba(0,0,0,0.1))',
              mixBlendMode: 'multiply'
            }}
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <span className="text-6xl">🧠</span>
          </div>
        )}
      </div>
      {showName && (
        <span 
          className={`${textSizeClasses[size]} ${nameColor}`}
          style={{ 
            fontFamily: "'Aref Ruqaa', 'Amiri', serif",
            fontWeight: 700,
            textShadow: size === 'hero' || size === 'giant' ? '2px 2px 4px rgba(0,0,0,0.15)' : 'none',
          }}
        >
          {APP_NAME}
        </span>
      )}
    </Link>
  );
};
